/* API request complete path */
export const API_URL = process.env.REACT_APP_API_URL+'/';

/* Website Url */
export const WEBSITE_URL = process.env.REACT_APP_WEBSITE_URL+'/';

/* Website Url */
export const WEBSITE_IMG_URL = WEBSITE_URL+'images/';

/* Key for API authentication */
export const API_HEADER_AUTH_KEY = process.env.REACT_APP_API_HEADER_AUTH_KEY;

/* Key for GOOGLE API key */
export const GOOGLE_API_KEY	=	process.env.REACT_APP_GOOGLE_API_KEY;

/* Languages configurations */
export const ENGLISH_LANGUAGE_MONGO_ID	= "5a3a13238481824b077b23ca";
export const ENGLISH_LANGUAGE_CODE		= "en";

/* Default language configurations */
export const DEFAULT_LANGUAGE_CODE		= ENGLISH_LANGUAGE_CODE;
export const DEFAULT_LANGUAGE_ID		= ENGLISH_LANGUAGE_MONGO_ID;

/** For currency symbol */
export const CURRENCY_CODE   = 'USD';
export const CURRENCY_SYMBOL = '$';

/** API status */
export const STATUS_SUCCESS = "success";
export const STATUS_ERROR 	= "error";

export const ROUND_PRECISION = 2;

/** Date format **/
export const AM_PM_FORMAT_WITH_DATE		=	"YYYY/MM/DD hh:mm A";
export const RATING_DATE_TIME_FORMAT	=	"DD/MM/YY";
export const JOB_DATE_FORMAT	        =	"DD/MM/YYYY";
export const DATERANGE_DATE_TIME_FORMAT	=	"MM/DD/YYYY";
export const CALENDAR_DATE_TIME_FORMAT	=	"YYYY-MM-DD 23:59:59";
export const DATE_PICKER_DATE_FORMAT	=	"MM/dd/YYYY";
export const TIME_PICKER_FORMAT         =	"hh:mm aa";
export const DEFAULT_DATE_FORMAT	    =	"MM/dd/YYYY";
export const DATE_RANGE_PICKER_FORMAT   =	"MM/dd/yyyy";
export const REPORT_DATE_FORMAT	        =	"MM/DD/YYYY";
export const CALENDAR_START_DATE_TIME_FORMAT	=	"YYYY-MM-DD 00:00:00";
export const CALENDAR_MODIFIED_DATE_TIME_FORMAT	=	"MM/DD/YYYY hh:mm A";


/** Time Format **/
export const AM_PM_FORMAT_WITH_TIME		=	"hh:mm a";

export const ACTIVE     =   1;
export const INACTIVE   =   0;
export const PROFILE_INACTIVE   =   2;

export const RADIO_YES  =   1;
export const RADIO_NO   =   0;

/** SHIFT status */
export const SHIFT_DAY  = "day";
export const SHIFT_NIGHT = "night";

/** Departments */
export const OSP_DEPARTMENT      =   "osp";
export const ISP_DEPARTMENT      =   "isp";
export const ELEC_DEPARTMENT     =   "elec";
export const HDD_DEPARTMENT      =   "hdd";
export const FIBER_DEPARTMENT    =   "fiber";
export const CTR_DEPARTMENT      =   "ctr";
export const OFFICE_DEPARTMENT   =   "office";
export const FEDERAL_DEPARTMENT  =   "federal";
export const RESTO_DEPARTMENT    =   "resto";
export const ENGINEERING_DEPARTMENT  =   "engineering";
// export const JBLM_DEPARTMENT     =   "jblm";\
export const TC_DEPARTMENT  =   "tc";


/** Department dropdown */
export const DEPARTMENT_DROPDOWN = [
    { value: CTR_DEPARTMENT,    label: 'CTR' },
    { value: HDD_DEPARTMENT,    label: 'HDD' },
    { value: ISP_DEPARTMENT,    label: 'ISP' },
    { value: OSP_DEPARTMENT,    label: 'OSP' },
    { value: ELEC_DEPARTMENT,   label: 'ELEC' },
    { value: FIBER_DEPARTMENT,  label: 'FIBER' },
    { value: RESTO_DEPARTMENT,  label: 'RESTO' },
    // { value: OFFICE_DEPARTMENT, label: 'OFFICE' },
    // { value: JBLM_DEPARTMENT,   label: 'JBLM' },
    { value: TC_DEPARTMENT,   label: 'TC' },
];

/** Department dropdown */
export const REQUEST_DEPARTMENT_DROPDOWN = [
    { value: CTR_DEPARTMENT,    label: 'CTR' },
    { value: HDD_DEPARTMENT,    label: 'HDD' },
    { value: ISP_DEPARTMENT,    label: 'ISP' },
    { value: OSP_DEPARTMENT,    label: 'OSP' },
    { value: ELEC_DEPARTMENT,   label: 'ELEC' },
    { value: FIBER_DEPARTMENT,  label: 'FIBER' },
    { value: FEDERAL_DEPARTMENT,  label: 'FEDERAL' },
    { value: ENGINEERING_DEPARTMENT,  label: 'ENGINEERING' },
];

export const PAGING_LENGTH_MENU = [10,20,50,100,1000];

/**EMPLOYEE PERMISSION LEVEL DROPDOWN */
export const ADMIN 		     =	"admin";
export const READ_ONLY 	     =	"read_only";
export const FOREMAN         =	"foreman";
export const PROJECT_MANAGER =	"project_manager";
export const DISPATCHER	     =	"dispatcher";
export const GENERIC_TV_LOGINS=	"generic_tv_logins";
export const NO_ACCESS_PERMISSION =	"no_access";

export const PERMISSION_LEVEL_DROPDOWN = [
    { value: ADMIN,             label: 'Super Admin' },
    { value: DISPATCHER,        label: 'Admin' },
    { value: PROJECT_MANAGER,   label: 'Dispatcher' },
    { value: FOREMAN,           label: 'Editor' },
    { value: READ_ONLY,         label: 'Read Only' },
    { value: GENERIC_TV_LOGINS, label: 'System User Account' },
];

/**SUBCONTRACTOR PERMISSION LEVEL DROPDOWN */
export const CONTRACTS_ADMIN 	=	"contracts_admin";
export const SAFETY_COMPLIANCE 	=	"safety_compliance";
export const DIRECTOR 			=	"director";

export const SUBCONTRACTOR_PERMISSION_LEVEL_DROPDOWN = [
    { value: ADMIN,             label: 'Super Admin' },
    { value: CONTRACTS_ADMIN,   label: 'Contracts Admin' },
    { value: SAFETY_COMPLIANCE, label: 'Safety Compliance' },
    { value: DIRECTOR, 			label: 'Director' },
    // { value: PROJECT_MANAGER,   label: 'Dispatcher' },
    // { value: READ_ONLY,         label: 'Read Only' },
    { value: NO_ACCESS_PERMISSION, label: 'No Access' },
];

/** Employee Role list */
export const CREW  = "crew";
export const EMPLOYEE_ROLE_DROPDOWN = [
    { value: DISPATCHER,label: 'Admin' },
    { value: PROJECT_MANAGER,   label: 'Dispatcher' },
    { value: FOREMAN,   label: 'Editor' },
    { value: CREW,      label: 'Crew' }
];

export const ALLOWED_MASTER_LIST = ["location","driver_tier_level","equipment_tier_level","hdd_drill_size","specialized_tools_ctr","headend_hub_location","job_title","badges","fiber_task","scope_of_work_type","hdd_locator_type",'surface_type','locate_type','skill_set','ctr_task','service_type'];

export const MASTER_DRIVER_TIER_LEVEL = 'driver_tier_level';
export const MASTER_LOCATION          = 'location';
export const MASTER_SKILL_SET         = 'skill_set';

/** Calendar Static Role id */
export const CALENDAR_PTO 			= 	"664db774f836b6d91fcb3639";
export const CALENDAR_YARD 			= 	"664db779f836b6d91fcb363b";
export const CALENDAR_SUB_CONTRACTOR =	"664db78af836b6d91fcb363d";
export const CALENDAR_ON_CALL_SCHEDULES =	"664db78af836b6d91fcb363b";
export const CALENDAR_UNASSIGNED_TC_JOBS =	"664db78af836b6d81fcb363t";

export const CALENDAR_STATIC_ROLE  = {
	[CALENDAR_YARD] 			: {name: "Yard", type: "yard"},
	[CALENDAR_PTO]  			: {name: "PTO", type: "pto"},
	[CALENDAR_SUB_CONTRACTOR] 	: {name: "Subcontractor", type: "subcontractor"},
	[CALENDAR_ON_CALL_SCHEDULES] :{name: "On Call", type: "on_call"},
	[CALENDAR_UNASSIGNED_TC_JOBS]:{name: "Not Scheduled", type: "unassigned"},
};


/** System export format */
export const EXPORT_PDF  =  "pdf" ;
export const EXPORT_CSV  =  "csv" ;

export const EXPORT_TYPE_DROPDOWN = [
    { value: EXPORT_PDF,    label: 'PDF' },
    { value: EXPORT_CSV,    label: 'CSV' }
];

/** Dashboard filter status */
export const CURRENT_DAY  = "day";
export const CURRENT_WEEK  = "week";
export const CURRENT_MONTH  = "month";

/**EMPLOYEE JOB FIELD LEVEL DROPDOWN */
export const JOB_TYPE_FIELD 	=	"field";
export const JOB_TYPE_OFFICE 	=	"office";

export const JOB_TITLE_TYPE_DROPDOWN = [
    { value: JOB_TYPE_FIELD,     label: 'Field' },
    { value: JOB_TYPE_OFFICE,    label: 'Office' }
];

export const ACTIVE_DEACTIVE_DROPDOWN = [
	{value: String(ACTIVE), label: "Active"},
	{value: String(INACTIVE), label: "Inactive"}
];

export const USER_ACTIVE_DEACTIVE_DROPDOWN = [
	{value: String(ACTIVE), label: "Active"},
	{value: String(INACTIVE), label: "Terminated"}
];

export const SUBCONTRACTOR_PROFILE_STATUS_DROPDOWN = [
    {value: String(ACTIVE), label: "Active"},
    {value: String(INACTIVE), label: "Suspended"},
    {value: String(PROFILE_INACTIVE), label: "Inactive"},
    // {value: String(ARCHIVED), label: "Archive"},
];

export const IS_RENTAL_DROPDOWN = [
	{value: String(ACTIVE), label: "Yes"},
	{value: String(INACTIVE), label: "No"}
];

export const OUT_OF_TOWN_DROPDOWN = [
	{value: String(ACTIVE), label: "Yes"},
	{value: String(INACTIVE), label: "No"}
];

export const PAID_UNPAID_DROPDOWN = [
	{value: "paid", label: "PTO"},
	{value: "unpaid", label: "Non PTO"}
];

/** Subcontractor Agreement Type */
export const MSA = "msa";
export const SINGLE_SUBCONTRACTOR = "single_subcontractor";
export const FEDERAL = "federal";
export const COI_ONLY             =   "coi_only";

export const AGREEMENT_TYPE_DROPDOWN = [
    {value: MSA, label: "Master Service Agreement (“MSA”)", shortCode : 'MSA'},
    {value: FEDERAL,  label: "Federal", shortCode : 'Federal' },
    {value: SINGLE_SUBCONTRACTOR, label: "Single Subcontract", shortCode : 'Single Subcontract' },
    {value: COI_ONLY, label: "COI Only", shortCode : 'COI Only' },
];

export const EQUIPMENT_STATUS_DROPDOWN = [
	{value: "A", label: "Active"},
	{value: "I", label: "Inactive"}
];

export const ALLOWED_IMAGE_EXTENSIONS = ["jpg", "jpeg", "png"];

/**FIELD LEVEL FOR TIME PERIOD DROPDOWN */
export const WEEKLY 	=	"weekly";
export const MONTHLY 	=	"monthly";
export const YEARLY 	=	"yearly";

export const TIME_PERIOD_DROPDOWN = [
	{value: WEEKLY, label: "Weekly"},
	{value: MONTHLY, label: "Monthly"},
	{value: YEARLY, label: "Yearly"}
];

/** Week days */
export const SUNDAY	 	= 0
export const MONDAY		= 1
export const TUESDAY	= 2
export const WEDNESDAY	= 3
export const THURSDAY	= 4
export const FRIDAY		= 5
export const SATURDAY	= 6

/** Weekday names map */
export const WEEK_DAYS = [
	{value: SUNDAY, label: "Sunday"},
	{value: MONDAY, label: "Monday"},
	{value: TUESDAY, label: "Tuesday"},
	{value: WEDNESDAY, label: "Wednesday"},
	{value: THURSDAY, label: "Thursday"},
	{value: FRIDAY, label: "Friday"},
	{value: SATURDAY, label: "Saturday"}
];

/**Default days for move/copy emp/equip last 60 days */
export const DEFAULT_COPY_DAYS	= 60

export const PROJECT_MANAGER_TYPE 	=	"project_manager";
export const SUPERVISOR_TYPE 	=	"supervisor";


export const SMS_LIMIT 	=	160;


export const SMS_TEMPLATE_DROPDOWN = [
    {
        value: 'schedule_notification',
        label: 'Schedule Notification'
    },
    {
        value: 'on_call_reminder',
        label: 'On-Call Reminder',
        message : "Team This is a reminder that you are currently on-call {{start_date}} - {{end_date}}. Please ensure you are available and reachable. Contact your PM with any questions. Roster: https://connect.teamcannon.com/on-call-roster"
    }
];

/**ON CALL SMS SCHEDULE TIME DROPDOWN */
export const SEND_NOW 	=	"send_now";
export const SEND_LATER =	"send_later";

export const SMS_SCHEDULE_DROPDOWN = [
	{value: SEND_NOW, label: "Send Now"},
	{value: SEND_LATER, label: "Send Later"}
];

/**TRAFFIC CONTROL DROPDOWN */
export const IN_HOUSE 	=	"in_house";
export const OUTSIDE =	"outside";

export const TRAFFIC_CONTROL_DROPDOWN = [
	{value: IN_HOUSE, label: "In-House"},
	{value: OUTSIDE, label: "Subcontractor"}
];